import React, { useEffect, useState } from "react";
import { Typography, Box, Button } from '@mui/material';
import { Dialog, useToggle } from '@genesis/ui-kit';
import axios from "axios";
import { constants, environmentVariables } from "../../Shared/Url/Constants";
import { useSelector } from "react-redux";
import Cookie from "js-cookie";
import { IsTokenValid } from "../../Shared/Utill/AuthUtil";
import "./unavailablePopup.module.scss";

const UnavailableEventPopup = (props) => {
    const dialog = useToggle();
    const personDetails = useSelector((state) => state.person.personData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const colleagueTKN = Cookie.get('X_TKN');
    const customQuery ='@media (max-width: 768px)';
    const personODSFuture = useSelector((state) => state.odsfuture.ODSFutureData);


    useEffect(() => {
        
        /*if (IsTokenValid(colleagueTKN)) {
            let homeUrl = urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_UI_BASE_URL
            window.location.replace(`${homeUrl}login`)
          } */ // isTokenValid
        dialog.show();
    }, []);

    const saveUnavailable = () => {
        // call unavailable for event api
        let data = {
            eventId: props.eventId,
            ascNbr: personDetails.emplID,
            locNbr: personODSFuture.mystore,
            divNbr: personODSFuture.mydiv,
            deleteOrInsert: "i",    
            lastUpdatedBy: personDetails.emplID,
            impersonatedBy: personDetails.impersonate_admin_id,
        }
        console.log("request payload",data)
          // setResetUnavailabilityService(data,false);
       
    }

    const setResetUnavailabilityService = (data, isReset) =>{
       
        let divUrl = `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_UPDATE_RESET_EVENT_UNAVAILABLE_BY_ASC_NBR_EVENT_ID}`
            return  axios({
                url: divUrl,
                method: "POST", 
                data: data, 
                headers : {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer ' + colleagueTKN,
                }, })
                .then((response) => {  
                    // success close popup
                    props.popupClose();
                    props.popupSave("success");             
            })
            .catch((error) => {
                //catch
                props.popupClose();
                props.popupSave("error");
            });
    }
    
    const closeDialog = () => {
        dialog.hide();
        props.popupClose(); 
    }

    /*const getDialogStyleVersion = () => {
        let widthD = "45%";
        let leftMargin = "45%";
        let topMargin = "20%";
        let rightMargin = "20%";
        let bottomMargin = "20%";
        let height = "20%";
        let maxWidth = 'xs';
        let fullWidth = true;
        if(window.innerWidth < 768){
            //mobile version
            widthD = "100%";
            height = "30vh";
            topMargin = "20%";
            bottomMargin = "20%"
            leftMargin = "0%";
            fullWidth=fullWidth;
            maxWidth=maxWidth;
          }else if(window.innerWidth <= 1300){
            // tablet
            widthD = "45%";
            //rightMargin = "40%";
            leftMargin = "0%";
          }else if(window.innerWidth > 1300){
            //desktop
            widthD = "45%";
            leftMargin = "28%";
          }
        return {
            width: widthD,
            maxWidth: widthD,
            display:"flex",
            left:leftMargin,
            minHeight:"100%"             
        }
    } */

    return (
        <div className="dialog">
        <Box>
        
        <Dialog
               
                sx={{
                    [customQuery]:{

                            '&. MuiDialogContent-root':{overflow:'unset'},

                            '& .MuiDialogTitle-root':{
                                padding: "0px 0px 6px"
                            },
                            '& .MuiDialog-paper':{
                                margin:"30px",
                                scale:2,
                                height:"45%",
                                minWidth:"100%"
                            }, 
                            ' .MuiDialogActions-root' : {
                                padding: "0px 0px 0% 0px"
                            }
                    }
                }}
                open={dialog.open}
                title={props.title}
                onClose={closeDialog}
                actions={
                    <>
                        <Button color="secondary" onClick={props.popupClose}>Cancel</Button>
                        
                        <Button onClick={props.popupSave}>Save</Button>
                        
                    </>
                }
            >
                <div><Typography>{props.message}</Typography></div> 
            </Dialog>
        
            
        </Box>
        </div>
    );
}

export default UnavailableEventPopup;

